import {
  Box,
  Divider,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Pagination,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activateMachineThunk,
  deleteMachineThunk,
  getMachinesThunk,
} from "store/reducers/vending";
import MachineCard from "pages/vending/machine/list/MachineCard";
import MachineCardLoading from "pages/vending/machine/list/MachineCardLoading";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import SoupKitchenIcon from "@mui/icons-material/SoupKitchen";
import PlaceIcon from "@mui/icons-material/Place";
import PasswordIcon from "@mui/icons-material/Password";
import EditBasicMachineDetails from "pages/vending/machine/operations/EditBasicMachineDetails";
import AddMoreCabins from "pages/vending/machine/operations/AddMoreCabins";
import AddMoreTrays from "pages/vending/machine/operations/AddMoreTrays";
import { useNavigate } from "react-router-dom";
import AssignPaymentsDialog from "pages/vending/machine/operations/AssignPaymentsDialog";
import AssignMachineAdminDialog from "pages/vending/machine/operations/AssignMachineAdminDialog";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import AssignMachineToLocationDialog from "pages/vending/machine/operations/AssignMachineToLocationDialog";
import AutoCompleteList from "components/AutoCompleteList";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import TvIcon from "@mui/icons-material/Tv";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import Person3Icon from "@mui/icons-material/Person3";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ValidationAssignmentDialog from "pages/product_validation/validationSetUp/ValidationAssignmentDialog";
import SmsAssignmentDialog from "pages/third_party_services/sms_provider/allocations/SmsAssignmentDialog";
import AssignFillingPersonDialog from "../operations/AssignFillingPersonDialog";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import "utils/protos";
import AssignAdminDialog from "../operations/AssignAdminDialog";
import ManageDisplayConfig from "../operations/ManageDisplayConfig";
import ChangeMachinePassword from "../operations/ChangeMachinePassword";
const MachineList = () => {
  const vendingState = useSelector((state) => state.vending);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.auth.user.roles);

  const [page, setPage] = useState(1);

  const kitchens = useSelector(locationSelector.selectAll);
  const [kitchen, setLocation] = useState(null);
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  useEffect(() => {
    dispatch(getMachinesThunk({ page, location: kitchen?.id ?? "" }));
  }, [dispatch, kitchen, page]);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };
  const [currentItem, setCurrentItem] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [contextMenu, setContextMenu] = React.useState(null);
  const [basicDetailsOpen, setBasicDetailsOpen] = React.useState(false);

  const handleBasicDetailsOpen = () => {
    setBasicDetailsOpen(false);
  };

  const [addMoreCabinsOpen, setAddMoreCabinsOpen] = React.useState(false);
  const handleAddMoreCabinsOpen = () => {
    setAddMoreCabinsOpen(false);
  };
  const openAddMoreCabins = (machine) => {
    setCurrentItem(machine);
    setAddMoreCabinsOpen(true);
  };

  const [addMoreTraysOpen, setAddMoreTraysOpen] = React.useState(false);
  const handleAddMoreTraysOpen = () => {
    setAddMoreTraysOpen(false);
  };
  const openAddMoreTrays = (machine) => {
    setCurrentItem(machine);
    setAddMoreTraysOpen(true);
  };

  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };

  const handleActivate = () => {
    console.log("inside", currentItem.active);
    if (currentItem.active) {
      console.log("its deleting");
      dispatch(deleteMachineThunk(currentItem.id));
    } else {
      dispatch(activateMachineThunk(currentItem.id));
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const [machinePaymentOpen, setMachinePaymentOpen] = React.useState(false);

  const handleMachinePaymentClose = () => {
    setMachinePaymentOpen(false);
  };

  const [machineAdminOpen, setMachineAdminOpen] = React.useState(false);

  const handleMachineAdminClose = () => {
    setMachineAdminOpen(false);
  };

  const [fillingPersonOpen, setFillingPersonOpen] = React.useState(false);

  const handleFillingPersonClose = () => {
    setFillingPersonOpen(false);
  };

  const [machineLocationOpen, setMachineLocationOpen] = React.useState(false);
  const [assignAdminOpen, setAssignAdminOpen] = React.useState(false);

  const handleMachineLocationClose = () => {
    setMachineLocationOpen(false);
  };
  const handleAssignAdminClose = () => {
    setAssignAdminOpen(false);
  };

  const [validationSetupOpen, setValidationSetupOpen] = React.useState(false);

  const handleValidationSetupClose = () => {
    setValidationSetupOpen(false);
  };

  const [displayConfigSetupOpen, setDisplayConfigOpen] = React.useState(false);

  const handleDisplayConfigClose = () => {
    setDisplayConfigOpen(false);
  };

  const [smsSetupOpen, setSmsSetupOpen] = React.useState(false);

  const setUpSmsClose = () => {
    setSmsSetupOpen(false);
  };
  const menuItems = [];

  const [changeCredentialOpen, setChangeCredentialOpen] = React.useState(false);
  const handleChangeCredentialOpen = () => {
    setChangeCredentialOpen(false);
  };

  if (roles.any(["super_admin", "admin"])) {
    menuItems.push(
      <MenuItem onClick={handleActivate}>
        <ListItemIcon>
          {currentItem?.active ? (
            <DoNotDisturbAltIcon fontSize="small" />
          ) : (
            <TaskAltIcon fontSize="small" />
          )}
        </ListItemIcon>
        {currentItem?.active ? "Deactivate machine" : "Activate machine"}
      </MenuItem>,
      <MenuItem
        onClick={() => {
          setBasicDetailsOpen(true);
        }}
      >
        <ListItemIcon>
          <BorderColorIcon fontSize="small" />
        </ListItemIcon>
        Edit basic details
      </MenuItem>,
      <MenuItem
        onClick={() => {
          setChangeCredentialOpen(true);
        }}
      >
        <ListItemIcon>
          <PasswordIcon fontSize="small" />
        </ListItemIcon>
        Change credentials
      </MenuItem>,
      <Divider />,

      <MenuItem
        onClick={() => {
          navigate(`/machines/${currentItem?.id}/trays-n-partitions`);
        }}
      >
        <ListItemIcon>
          <ViewModuleIcon fontSize="small" />
        </ListItemIcon>
        Manage trays
      </MenuItem>,
      <Divider />,
      <MenuItem
        onClick={() => {
          setMachinePaymentOpen(true);
        }}
      >
        <ListItemIcon>
          <CreditCardIcon fontSize="small" />
        </ListItemIcon>
        Assign payments
      </MenuItem>,
      <Divider />
    );
  }

  if (roles.any(["machine_admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          setChangeCredentialOpen(true);
        }}
      >
        <ListItemIcon>
          <PasswordIcon fontSize="small" />
        </ListItemIcon>
        Change credentials
      </MenuItem>,
      <Divider />
    );
  }

  if (roles.any(["super_admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          setAssignAdminOpen(true);
        }}
      >
        <ListItemIcon>
          <VerifiedUserIcon fontSize="small" />
        </ListItemIcon>
        {currentItem?.admin ? "Change admin" : "Assign to Admin"}
      </MenuItem>
    );
  }

  if (roles.any(["super_admin", "admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          setMachineLocationOpen(true);
        }}
      >
        <ListItemIcon>
          <PlaceIcon fontSize="small" />
        </ListItemIcon>
        {currentItem?.kitchen ? "Change location" : "Assign to location"}
      </MenuItem>,
      <Divider />
    );
  }

  if (roles.any(["super_admin", "admin", "machine_admin", "filling_person"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          navigate(`/machines/${currentItem?.id}/refill`);
        }}
      >
        <ListItemIcon>
          <SoupKitchenIcon fontSize="small" />
        </ListItemIcon>
        Product refill
      </MenuItem>,
      <Divider />
    );
  }

  if (roles.any(["super_admin", "admin", "machine_admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          navigate(`/machines/${currentItem?.id}/ads`);
        }}
      >
        <ListItemIcon>
          <OndemandVideoIcon fontSize="small" />
        </ListItemIcon>
        Manage ads
      </MenuItem>,
      <Divider />
    );
  }

  if (roles.any(["super_admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          setDisplayConfigOpen(true);
        }}
      >
        <ListItemIcon>
          <TvIcon fontSize="small" />
        </ListItemIcon>
        Manage configuration
      </MenuItem>
    );
  }

  if (roles.any(["super_admin", "admin"])) {
    menuItems.push(
      <MenuItem
        onClick={() => {
          setValidationSetupOpen(true);
        }}
      >
        <ListItemIcon>
          <DomainVerificationIcon fontSize="small" />
        </ListItemIcon>
        Setup validation
      </MenuItem>,
      <Divider />,
      <MenuItem
        onClick={() => {
          setMachineAdminOpen(true);
        }}
      >
        <ListItemIcon>
          <AdminPanelSettingsIcon fontSize="small" />
        </ListItemIcon>
        Manage machine admins
      </MenuItem>,
      <MenuItem
        onClick={() => {
          setFillingPersonOpen(true);
        }}
      >
        <ListItemIcon>
          <Person3Icon fontSize="small" />
        </ListItemIcon>
        Manage delivery boys
      </MenuItem>,
      <Divider />,
      <MenuItem onClick={() => {}}>
        <ListItemIcon>
          <EqualizerIcon fontSize="small" />
        </ListItemIcon>
        View sales report
      </MenuItem>
    );
  }

  const menu = (context) => (
    <Menu
      {...(context
        ? {
            open: contextMenu !== null,
            anchorReference: "anchorPosition",
            anchorPosition:
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
          }
        : {
            anchorEl: anchorEl,
            open: anchorEl !== null,
          })}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        {/* {menuItems.map((item,key) => {
          item.key = key
          return item
        })} */}
        {React.Children.toArray(menuItems)}
      </MenuList>
    </Menu>
  );
  return (
    <Box
      maxWidth
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Grid container spacing={1} sx={{ mb: 2, ml: 1, pr: 3 }}>
        <Grid item lg={4} md={6} xs={12}>
          <AutoCompleteList
            items={kitchens}
            name="name"
            label="Filter by location"
            setValue={setLocation}
            value={kitchen}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} maxWidth justify="center">
        {vendingState.getAllMachinesLoading &&
        vendingState.machines.length === 0
          ? Array(3)
              .fill("")
              ?.map((item, index) => <MachineCardLoading key={index} />)
          : vendingState.machines?.map((machine) => (
              <Grid key={machine.id} item xl={3} lg={4} md={4} sm={6} xs={12}>
                <MachineCard
                  machine={machine}
                  handleClick={handleClick}
                  handleContextMenu={handleContextMenu}
                  openAddMoreCabins={openAddMoreCabins}
                  openAddMoreTrays={openAddMoreTrays}
                />
              </Grid>
            ))}
      </Grid>
      <Stack direction="row" justifyContent="center" marginTop={2}>
        <Pagination
          count={vendingState.machinePageCount}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </Stack>
      {menu(false)}
      {menu(true)}
      <EditBasicMachineDetails
        open={basicDetailsOpen}
        handleClose={handleBasicDetailsOpen}
        machine={currentItem}
      />
      <AddMoreCabins
        open={addMoreCabinsOpen}
        handleClose={handleAddMoreCabinsOpen}
        machine={currentItem}
      />
      <AddMoreTrays
        open={addMoreTraysOpen}
        handleClose={handleAddMoreTraysOpen}
        machine={currentItem}
      />
      {currentItem && (
        <>
          <AssignPaymentsDialog
            open={machinePaymentOpen}
            handleClose={handleMachinePaymentClose}
            machine={currentItem}
          />
          <AssignMachineAdminDialog
            open={machineAdminOpen}
            handleClose={handleMachineAdminClose}
            machine_id={currentItem.id}
          />
          <AssignAdminDialog
            open={assignAdminOpen}
            handleClose={handleAssignAdminClose}
            machine_id={currentItem.id}
          />
          <AssignFillingPersonDialog
            open={fillingPersonOpen}
            handleClose={handleFillingPersonClose}
            machine_id={currentItem.id}
          />
          <AssignMachineToLocationDialog
            open={machineLocationOpen}
            handleClose={handleMachineLocationClose}
            machine_id={currentItem.id}
          />
          <ValidationAssignmentDialog
            open={validationSetupOpen}
            handleClose={handleValidationSetupClose}
            machine={currentItem}
          />
          <SmsAssignmentDialog
            open={smsSetupOpen}
            handleClose={setUpSmsClose}
            machine={currentItem}
          />
          <ManageDisplayConfig
            open={displayConfigSetupOpen}
            handleClose={handleDisplayConfigClose}
            machine={currentItem}
          />
          <ChangeMachinePassword
            open={changeCredentialOpen}
            handleClose={handleChangeCredentialOpen}
            machine={currentItem}
          />
        </>
      )}
    </Box>
  );
};

export default MachineList;
